function getLocationValues(variables: any): string[] {
	if (typeof variables?.location === 'string' && variables.location.length > 0) {
		return [variables.location];
	}

	if (Array.isArray(variables?.locations) && variables.locations.length > 0) {
		return variables.locations.filter((location: unknown): location is string => !!location);
	}

	return [];
}

export function getQueryName(
	operationName: string | null | undefined,
	variables: any,
	sanitize: boolean = false,
): string {
	if (!operationName) return '';

	let name = operationName;
	if (operationName === 'WebItemLocationQuery' || operationName === 'WebPanelLocationQuery') {
		name = `${operationName}:${
			variables?.location || (variables?.locations || []).join(',') || ''
		}`;
	} else if (operationName === 'FetchPreFilteredForgeAppsQuery') {
		name = `${operationName}:${variables?.types?.join(',') || ''}`;
	} else if (operationName === 'onboardingStateGetOnboardingStateQuery') {
		const keys = Array.isArray(variables?.key) ? variables.key : [];
		if (keys.length === 1) {
			name = `${operationName}:${keys[0] || ''}`;
		} else if (keys.length > 1) {
			const firstKey = keys[0] || '';
			name = `${operationName}:${firstKey}_${keys.length}`;
		}
	}
	if (sanitize) {
		return name.replace(/[^\-\.\w]/g, '_');
	}
	return name;
}

export function getEquivalentQueryNames(
	operationName: string | null | undefined,
	variables: any,
	sanitize: boolean = false,
) {
	if (!operationName) return [];

	if (operationName !== 'WebPanelLocationQuery') {
		return [getQueryName(operationName, variables, sanitize)];
	}

	const locations = getLocationValues(variables);
	if (locations.length <= 1) {
		return [getQueryName(operationName, variables, sanitize)];
	}

	return locations.map((location) =>
		getQueryName(
			operationName,
			{
				...variables,
				location,
				locations: [],
			},
			sanitize,
		),
	);
}
